import { Component, input, ChangeDetectionStrategy } from '@angular/core';

import { SalesPrice } from '../../types/sales-price';
import { PriceCardComponent } from '../price-card/price-card.component';

import { FormatPipe } from '@softline/ui-core';
@Component({
    selector: 'soft-sales-price-card',
    imports: [PriceCardComponent,
    FormatPipe],
    templateUrl: './sales-price-card.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './sales-price-card.component.css'
})
export class SalesPriceCardComponent {
  salesPrice = input.required<SalesPrice>();
}
